import React from 'react';

// Markdown-lite renderer for note text: line breaks, "- " bullet lists and
// **bold**. Builds React nodes only (no HTML parsing), so arbitrary input —
// including markup — renders as plain text.

const renderInline = (text: string): React.ReactNode[] =>
  text.split(/\*\*(.+?)\*\*/g).map((part, i) =>
    i % 2 === 1 ? <strong key={i}>{part}</strong> : <React.Fragment key={i}>{part}</React.Fragment>,
  );

const NoteMarkdown: React.FC<{ text: string }> = ({ text }) => {
  const lines = text.split('\n');
  const blocks: React.ReactNode[] = [];
  let bullets: string[] = [];

  const flushBullets = (key: number) => {
    if (!bullets.length) return;
    blocks.push(
      <ul key={`ul-${key}`} style={{ margin: '4px 0', paddingLeft: 18 }}>
        {bullets.map((item, i) => (
          <li key={i}>{renderInline(item)}</li>
        ))}
      </ul>,
    );
    bullets = [];
  };

  lines.forEach((line, i) => {
    const bullet = line.match(/^\s*-\s+(.*)$/);
    if (bullet) {
      bullets.push(bullet[1]);
      return;
    }
    flushBullets(i);
    if (line.trim() === '') {
      blocks.push(<div key={i} style={{ height: 6 }} />);
    } else {
      blocks.push(
        <div key={i} style={{ wordBreak: 'break-word' }}>
          {renderInline(line)}
        </div>,
      );
    }
  });
  flushBullets(lines.length);

  return <>{blocks}</>;
};

export default NoteMarkdown;
